<template>
  <div>
    <div v-if="hide">
      <div class="hide" :data-qr-code="access.id"></div>
      <div>
        <a
          class="primary--text"
          data-qr-image
          :download="`${access.name}_qr.png`"
          :href="qrFile"
        >
          <v-btn small icon>
            <v-icon color="black">download</v-icon>
          </v-btn>
        </a>
      </div>
    </div>
    <div v-else style="justify-content: center; display: flex">
      <div>
        <div :data-qr-code="access.id"></div>
        <div style="text-align: center">
          <a
            style="text-decoration: none"
            class="primary--text subheading font-weight-medium"
            data-qr-image
            :download="`${access.name}_qr.png`"
            :href="qrFile"
          >
            <v-icon color="primary">download</v-icon>
            Descargar
          </a>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import QrCreator from 'qr-creator'

export default {
  props: {
    hide: {
      type: Boolean,
      default: false,
      required: false,
    },
    access: {
      type: Object,
      default: {},
      required: true,
    },
  },
  data: () => ({
    qrFile: undefined,
  }),
  mounted() {
    this.setup()
  },
  methods: {
    setup() {
      this.setupQr()
      this.setupDownload()
    },
    setupDownload() {
      this.qrFile = document
        .querySelector(`[data-qr-code="${this.access.id}"] canvas`)
        .toDataURL()
    },
    setupQr() {
      document.querySelector(`[data-qr-code="${this.access.id}"]`).innerHTML =
        ''
      QrCreator.render(
        {
          text: this.access.identifier,
          radius: 0,
          ecLevel: 'H',
          fill: '#000000',
          background: '#ffffff',
          size: 1000,
        },
        document.querySelector(`[data-qr-code="${this.access.id}"]`)
      )
      document.querySelector(
        `[data-qr-code="${this.access.id}"] canvas`
      ).style.maxWidth = '200px'
      document.querySelector(
        `[data-qr-code="${this.access.id}"] canvas`
      ).style.width = '100%'
    },
  },
}
</script>

<style scoped>
.hide {
  display: none;
}
</style>
